import type { ReactElement } from "react";
import { Button, Modal } from "@playbookai/ui";

/** The "Learn more" dialog: what the audit history records, and how exports
    behave. Copy only — it reads nothing and changes nothing. */
export function AuditLearnMore({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Understanding audit history"
      description="How workspace and access changes are recorded, reviewed and exported."
      describedBy="audit-history-help"
      size="md"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Done
        </Button>
      }
    >
      <div
        id="audit-history-help"
        className="space-y-4 text-sm text-pb-text-secondary"
      >
        <section>
          <h3 className="font-semibold text-pb-text">One complete history</h3>
          <p className="mt-1">
            Workspace activity, membership grants and removals, and role changes
            appear together in one newest-first timeline.
          </p>
        </section>
        <section>
          <h3 className="font-semibold text-pb-text">Append-only record</h3>
          <p className="mt-1">
            Recorded events cannot be edited or deleted. Removing a member does
            not remove their earlier activity from the history.
          </p>
        </section>
        <section>
          <h3 className="font-semibold text-pb-text">
            Filters and event details
          </h3>
          <p className="mt-1">
            Filter by source service or full calendar days in your Region time
            zone. Open any row for a readable event summary or to copy its
            masked details as JSON.
          </p>
        </section>
        <section>
          <h3 className="font-semibold text-pb-text">CSV exports</h3>
          <p className="mt-1">
            Exports use the filters currently shown and include access changes.
            A file contains up to 10,000 of the most recent matching events;
            narrow the filters when the page reports that more exist.
          </p>
        </section>
      </div>
    </Modal>
  );
}
